import { Transition } from '@headlessui/react';
import { FC } from 'react';

import { ChevronDownIcon, PlusIcon } from '../../assets/icons/index';
import img from '../../assets/images/scroll.png';
import { AppFormattedMessage } from '../../components/app-formatted-message/index';
import { Select, SelectButton, SelectOption, SelectOptions } from '../../components/select/index';
import { ScenarioType, ScenarioTypeTitle } from '../../types/scenario-modeling.types';

export type EmptyScenarioModelingProps = {
  onAddFundraisingClick: () => void;
  onAddLiquidityClick: () => void;
  selected: ScenarioType;
  setSelected: (selected: ScenarioType) => void;
  showButton: boolean;
};

export const EmptyScenarioModeling: FC<EmptyScenarioModelingProps> = ({
  onAddLiquidityClick,
  onAddFundraisingClick,
  showButton,
  selected,
  setSelected,
}) => {
  const selectVariant = Object.values(ScenarioType);

  const handleSelect = (select: ScenarioType) => {
    setSelected(select);

    if (select === ScenarioType.FUNDRAISING) onAddFundraisingClick();
    if (select === ScenarioType.LIQUIDITY) onAddLiquidityClick();
  };

  return (
    <div className="radial-gradient-border-green centered relative m-auto flex h-fit flex-col gap-6 rounded-2xl px-6 py-8 xlg:my-[100px] lg:my-20 lg:max-w-[393px]">
      <div
        className="rounded-full bg-white p-3"
        style={{
          boxShadow: '0px 0px 8px 0px #12B76A21 inset',
        }}
      >
        <div
          className="centered flex size-28 items-center gap-3 rounded-full"
          style={{
            background:
              ' linear-gradient(180deg, rgba(18, 183, 106, 0.13) 0%, rgba(2, 122, 72, 0.13) 100%)',
          }}
        >
          <div className="size-[56px] object-cover">
            <img alt="" src={img} />
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center gap-2">
        <span
          className="!bg-clip-text text-xl font-semibold text-transparent"
          style={{
            background: 'linear-gradient(132.59deg, #475467 29.58%, #101828 84.27%)',
          }}
        >
          <AppFormattedMessage id="NO_SCENARIO_FOUND" />
        </span>
        <span className="max-w-[323px] text-center text-xs font-[450] text-gray-500">
          <AppFormattedMessage id="WHEN_AVAILABLE_SCENARIOS" />
        </span>
      </div>

      {showButton && (
        <Select onChange={handleSelect} value={selected}>
          {({ open }) => (
            <>
              <div className="relative rounded border-gray-200">
                <SelectButton className="w-[147px] bg-brand-700">
                  <PlusIcon />
                  <span className="text-sm font-[450] text-white">
                    <AppFormattedMessage id="SCENARIO" />
                  </span>
                  <ChevronDownIcon className="ml-2 h-4 w-4" iconColor="#ffffff" />
                </SelectButton>

                <Transition
                  as="div"
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                  show={open}
                >
                  <SelectOptions className="w-[147px]">
                    {selectVariant.map((select) => (
                      <SelectOption
                        className="px-0"
                        key={select}
                        selectedClassName="bg-white"
                        value={select}
                      >
                        <span className="block text-sm font-normal text-gray-700">
                          <AppFormattedMessage id={ScenarioTypeTitle[select]} />
                        </span>
                      </SelectOption>
                    ))}
                  </SelectOptions>
                </Transition>
              </div>
            </>
          )}
        </Select>
      )}
    </div>
  );
};
